import { sdk } from '@/sdk/CommercetoolsSDK';
import getCookieValue from '@/utils/cookie';
import { SDKResponse } from '@commercetools/frontend-sdk';
import { BusinessUnit } from '@shared/types/business-unit';

export class BusinessUnitService {
    businessUnitPromise: Promise<SDKResponse<BusinessUnit[]>> | null;
    businessUnits: BusinessUnit[];
    unitsFetched: boolean;
    selectedCompany: string;
    promises: any;

    constructor() {
        this.businessUnitPromise = null;
        this.businessUnits = [];
        this.unitsFetched = false;
        this.selectedCompany = '';
        this.promises = {};
    }

    public getUnitsFetchedFlag() {
        return this.unitsFetched;
    }

    public async getAllUnits(): Promise<SDKResponse<BusinessUnit[]>> {
        try {

            if (!this.businessUnitPromise) {
                const extensions = sdk.composableCommerce;
                this.businessUnitPromise = extensions.businessUnit.getBusinessUnits({ expandStores: true });
            }
            const response = await this.businessUnitPromise;
            this.businessUnits = response.isError ? [] : response.data ?? [];
            if (response.isError) {
                this.businessUnitPromise = null;
            } else {
                this.unitsFetched = true;
            }
            return response;
        } catch (e) {
            this.businessUnitPromise = null;
            this.businessUnits = [];
            console.log('failed to fetch businessUnits:: error:', e);
            return { isError: true } as SDKResponse<any>;
        }
    }

    public async getBusinessUnits() {
        if (this.businessUnits?.length) {
            return this.businessUnits;
        }
        await this.getAllUnits();
        return this.businessUnits;
    }
    public getDefaultBusinessUnit(units: BusinessUnit[], loggedIn: boolean) {
        if (loggedIn && units?.length) {
            const locale = getCookieValue('locale');
            const [firstUnit] = units;
            if (locale) {
                const selectedUnit = units.find((unit) => {
                    return unit.addresses?.some((address) => address.country?.toLowerCase() === locale.toLowerCase())
                });
                return selectedUnit ?? firstUnit;
            }
            return firstUnit;
        }
        return undefined;
    };

    public async getCurrentUnit(accountId: string) {
        await this.getAllUnits();
        const filteredBusinessUnits = this.businessUnits.filter(unit =>
            unit.associates?.some((associate) =>
                associate.accountId === accountId &&
                associate.roles?.every((roles) => roles.key !== "inactive")
            )
        );
        const defaultBusinessUnit = this.getDefaultBusinessUnit(this.businessUnits, true);
        const businessUnit = localStorage.getItem('business-unit') ?? (defaultBusinessUnit?.key as string);
        const selectedBusinessUnitKey = filteredBusinessUnits.find((unit) => unit.key === businessUnit)?.key;
        return selectedBusinessUnitKey ?? filteredBusinessUnits[0]?.key ?? '';
    }

    public clearBusinessUnits() {
        this.unitsFetched = false;
        this.businessUnitPromise = null;
        this.businessUnits = [];
        this.selectedCompany = '';
        this.promises = {};
    }

    public async selectCompany(company: string) {
        if (this.selectedCompany !== company && this.promises[this.selectedCompany]) {
            this.promises[this.selectedCompany] = null;
        }
        this.selectedCompany = company;
        
    }

    public updateCompany() {
        if (this.promises[this.selectedCompany]) {
            return;
        }
        const promise = sdk.composableCommerce.account.updateBusinessUnitSelection(this.selectedCompany);
        this.promises[this.selectedCompany] = promise;
    }
}
const businessUnitService = new BusinessUnitService();

export default businessUnitService;
